export default __webpack_public_path__ + "static/media/inspectors_sacrificial_knife.5384d12d.png";